'use es6';

import AsyncComponentLoading from 'email-management-lib/refactor/components/app/asyncLoaders/AsyncComponentLoading';
import Loadable from 'UIComponents/decorators/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncAssignAssetAccessPanelContainer = Loadable({
  loader: () => import( /* webpackChunkName: "assign-asset-access-panel" */'email-management-lib/refactor/containers/AssignAssetAccessPanelContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "assign-asset-access-panel"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "assign-asset-access-panel"
  }, props, {
    navMarkerErrorName: "ASSIGN_ASSET_ACCESS_PANEL_LOAD_FAILED"
  }))
});
export default AsyncAssignAssetAccessPanelContainer;